import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Scale, MessageCircle } from 'lucide-react';
import PolicyLayout from './PolicyLayout';
import { getWhatsAppLink } from '../lib/utils';

function TermsConditions() {
  return (
    <>
      <Helmet>
        <title>Terms & Conditions - OldCoinage.com</title>
        <meta name="description" content="Read our terms and conditions for using OldCoinage.com's services." />
      </Helmet>

      <PolicyLayout title="Terms & Conditions" lastUpdated="March 15, 2024">
        <div className="bg-amber-50 border border-amber-100 rounded-lg p-6 mb-8">
          <div className="flex items-start gap-4">
            <Scale className="h-6 w-6 text-amber-600 mt-1" />
            <div>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">Legal Agreement</h2>
              <p className="text-gray-600">
                By accessing or using OldCoinage.com, you agree to be bound by these terms and conditions.
              </p>
            </div>
          </div>
        </div>

        <h2>Acceptance of Terms</h2>
        <p>
          These terms and conditions govern your use of OldCoinage.com. By accessing or using our website, you agree to these terms in full.
        </p>

        <h2>User Accounts</h2>
        <p>
          When you create an account with us, you guarantee that:
        </p>
        <ul>
          <li>The information you provide is accurate and complete</li>
          <li>You are at least 18 years old</li>
          <li>You will maintain the accuracy of your information</li>
          <li>You will keep your password secure</li>
        </ul>

        <h2>Product Listings</h2>
        <p>
          All products listed on OldCoinage.com:
        </p>
        <ul>
          <li>Are authenticated by our expert numismatists</li>
          <li>Come with a certificate of authenticity</li>
          <li>Are accurately described to the best of our knowledge</li>
          <li>Are priced in Indian Rupees (₹)</li>
        </ul>

        <h2>Intellectual Property</h2>
        <p>
          All content on OldCoinage.com, including but not limited to text, graphics, logos, images, and software, is our property and is protected by Indian and international copyright laws.
        </p>

        <h2>Limitation of Liability</h2>
        <p>
          OldCoinage.com and its affiliates will not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of our services.
        </p>

        <h2>Governing Law</h2>
        <p>
          These terms are governed by and construed in accordance with Indian law. Any disputes shall be subject to the exclusive jurisdiction of the courts in Mumbai, India.
        </p>

        <div className="bg-primary-50 border border-primary-100 rounded-lg p-6 mt-8">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Questions About Our Terms?</h2>
          <p className="text-gray-600 mb-4">
            If you have any questions about our Terms & Conditions, please contact us:
          </p>
          <a
            href={getWhatsAppLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-600 text-white rounded-full hover:bg-primary-700 transition-colors font-medium"
          >
            <MessageCircle className="h-5 w-5" />
            Chat on WhatsApp
          </a>
        </div>
      </PolicyLayout>
    </>
  );
}

export default TermsConditions;